import React from 'react';

import moment from 'moment';

const SubscriptionCancellationDate = ({ status, cancellationDate }) => {
  const label = status === 'NON_RENEWING' ? 'Scheduled cancellation' : status === 'CANCELLED' ? 'Cancelled on' : null;
  const date = moment.utc(cancellationDate, 'YYYY-MM-DD', true);
  if (!label || !cancellationDate || !date.isValid()) return null;
  return (
    <div className='font-size-12 text-gray-500'>
      {label}: {date.format('MMM DD, YYYY')}
    </div>
  );
};

export default SubscriptionCancellationDate;
